import { Types } from 'mongoose';
import { z } from 'zod';

export const SubflowTemplateSchema = z.object({
  _id: z.instanceof(Types.ObjectId),
  name: z.string(),
  createdFrom: z.object({
    id: z.string(),
    name: z.string(),
  }),
  createdBy: z.object({
    id: z.string(),
    name: z.string(),
  }),
  blocks: z.array(z.any()),
  createdAt: z.date().optional(),
});

export const CreateSubflowTemplateSchema = SubflowTemplateSchema.pick({
  name: true,
  createdFrom: true,
  createdBy: true,
  blocks: true,
});

export const SubflowTemplateFormSchema = SubflowTemplateSchema.pick({
  name: true,
  blocks: true,
});
